"use client";

import { Link } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { LinksEditor, type LinksEditorProps } from "./links-editor";
import type { EditorLink } from "./link-records";
import { linkStyles as styles } from "./links.stylex";

type EditableLinksViewProps =
  | Readonly<{
      mode: "read";
      hasLockedLinks: boolean;
      links: readonly EditorLink[];
    }>
  | LinksEditorProps;

export function EditableLinksView(props: EditableLinksViewProps) {
  if (props.mode === "edit") return <LinksEditor {...props} />;

  if (props.links.length === 0) return null;

  return (
    <div {...stylex.props(styles.stack)}>
      {props.hasLockedLinks ? (
        <p {...stylex.props(styles.label)}>Your links</p>
      ) : null}
      <ul {...stylex.props(styles.list)}>
        {props.links.map((link) => (
          <li key={link.url}>
            <Link
              focus="native"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label} ↗
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
